import DialogModal from "../../_atoms/admin/DialogModal";

/**
 * Modal to question something to user
 * @param {Object} props
 * @param {function} [props.onClose = null]
 * @param {String} props.title
 * @param {String} props.questionText
 * @param {function} [props.onCancel = null]
 * @param {String} [props.cancelLabel = "No"]
 * @param {function} props.onConfirm
 * @param {String} [props.confirmLabel = "Sì"]
 *
 * @returns {JSX.Element}
 * @constructor
 */
const QuestionModal = (props) => {
    const onConfirm = () => {
        props.onClose();
        props.onConfirm();
    }

    const onCancel = () => {
        props.onClose();
        if (props.onCancel){
            props.onCancel();
        }
    }

    return <>
        <DialogModal
            onClose={props.onClose}
            open
            fullWidth
            title={props.title}
            actions={[
                {
                    variant: 'outlined',
                    onClick: onCancel,
                    color: 'brGrey',
                    label: props.cancelLabel ? props.cancelLabel : "No"
                },
                {
                    variant: 'contained',
                    onClick: onConfirm,
                    label: props.confirmLabel ? props.confirmLabel : 'Sì'
                }
            ]}
            >
            {props.questionText}
        </DialogModal>
    </>
}

export default QuestionModal;